export default "__VITE_ASSET__98503ffc__"